import { useStaticQuery, graphql } from 'gatsby'
export const SideBarDataQuery = () => {
  const sideBarData = useStaticQuery(
    graphql`
      query {
        tags: allContentfulNewsTag {
          nodes {
            name
            slug
          }
        }
        categories: allContentfulNewsCategory {
          nodes {
            name
            slug
          }
        }
        post: allContentfulNewsPost(sort: { fields: [createdAt], order: [DESC] }, limit: 8) {
          nodes {
            id
            title
            content {
              content
            }
            slug
            createdAt(formatString: "YYYY-MM-DD")
          }
        }
      }
    `,
  )
  return sideBarData
}
